import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <div className="App min-h-screen flex flex-col bg-[#FAFAFA]">
      <Navbar />
      <main className="flex-1 pt-[4.5rem] sm:pt-[4.75rem] md:pt-[7.25rem] lg:pt-[7.75rem]">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
